import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth';

export const AuthGuard: CanActivateFn = () => {
  const _authService = inject(AuthService);
  const router = inject(Router);

  if (_authService.isLoggedIn()) {
    return true;
  }
  router.navigate(['/login']);
  return false;
};
